import { getReverseProposalGoods } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  SearchReverseProposalGoodsServiceRequest,
  SearchReverseProposalGoodsServiceResponse,
} from './search-reverse-proposal-goods.dto';
import {
  SearchReverseProposalGoodsServiceRequestSchema,
  SearchReverseProposalGoodsServiceResponseSchema,
} from './search-reverse-proposal-goods.dto';

export const searchReverseProposalGoodsService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(SearchReverseProposalGoodsServiceRequestSchema),
    async (
      request: SearchReverseProposalGoodsServiceRequest,
    ): Promise<SearchReverseProposalGoodsServiceResponse> => {
      const apiResponse = await getReverseProposalGoods(request);

      if (apiResponse.meta?.result === 'FAIL') {
        throw new Error(apiResponse.meta?.message ?? '상품 검색에 실패했습니다.');
      }

      const hasNextPage = apiResponse.link?.next !== null && apiResponse.link?.next !== undefined;
      const nextPage = hasNextPage ? request.page + 1 : undefined;

      return {
        list: apiResponse.data.list,
        total: apiResponse.link?.total ?? 0,
        pagination: {
          currentPage: request.page,
          pageSize: request.size,
          hasNextPage,
          nextPage,
        },
      };
    },
    validateServiceResponse(SearchReverseProposalGoodsServiceResponseSchema),
  ),
);
